<script setup lang="ts"></script>

<template>
  <div class="app-sad-message">
    <IllustrationSadFace />

    <div>
      <h2 class="mb-6"><slot name="title"></slot></h2>

      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-sad-message {
  display: flex;
  align-items: center;

  & > svg {
    width: 8.75rem;
    height: auto;
    margin-right: 5rem;
    color: $black;
  }
}
</style>
